import Vue from 'vue'
import {fetchSystemTableViewPreferences, saveSystemTableViewPreference} from '@/api/modules/system'

const COMPACT = 'COMPACT'
const FULL = 'FULL'
const state = Vue.observable({
  modeByKey: {},
  initialized: false,
})

let loadingPromise = null
let generation = 0

/** 登录后加载一次当前账号的列表字段视图偏好。 */
export async function initializeTableViewPreferences() {
  if (state.initialized) return
  if (loadingPromise) return loadingPromise

  const currentGeneration = generation
  loadingPromise = fetchSystemTableViewPreferences()
      .then((rows) => {
        if (currentGeneration !== generation) return
        const modeByKey = {}
        ;(rows || []).forEach((item) => {
          if (item && item.viewKey && [COMPACT, FULL].includes(item.viewMode)) {
            modeByKey[item.viewKey] = item.viewMode
          }
        })
        state.modeByKey = modeByKey
        state.initialized = true
      })
      .finally(() => {
        if (currentGeneration === generation) loadingPromise = null
      })
  return loadingPromise
}

/** 未保存过的列表默认使用精简字段。该读取直接依赖响应式状态，页面会随保存结果重绘。 */
export function isTableViewFull(viewKey) {
  return state.modeByKey[viewKey] === FULL
}

/** 保存成功后才更新本地状态，失败时页面会保留原视图。 */
export async function saveTableViewMode(viewKey, viewMode) {
  const saved = await saveSystemTableViewPreference({viewKey, viewMode})
  Vue.set(state.modeByKey, saved.viewKey, saved.viewMode)
  state.initialized = true
  return saved
}

/** 退出登录或登录失效时清空上一个账号的偏好，防止短暂串号。 */
export function resetTableViewPreferences() {
  generation += 1
  loadingPromise = null
  state.modeByKey = {}
  state.initialized = false
}
